export default {
  routes: [
    {
      path: '/basic-experience',
      name: 'basicExperience',
      meta: {
        title: '基础体验汇总'
      },
      component: () =>
        import(/* webpackChunkName: "basicExperience" */ '../views/basicExperience/index.vue')
    },
    {
      path: '/basic-test',
      name: 'basicTest',
      meta: {
        title: '基础体验测试'
      },
      component: () =>
        import(/* webpackChunkName: "basicTest" */ '../views/basicTest/index.vue')
    }
  ]
}
